import { render, staticRenderFns } from "./BoEvent.vue?vue&type=template&id=b433181a&"
import script from "./BoEvent.vue?vue&type=script&lang=js&"
export * from "./BoEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports